import type { User } from "@/types";

/**
 * Panelga umuman kirish uchun kerak bo'ladigan ruxsat.
 *
 * Alohida ruxsat sifatida ajratilgan: "menyuda hech narsa yo'q, lekin
 * sahifa ochilib turibdi" holati bo'lmasligi kerak.
 */
export const ADMIN_ENTRY_PERMISSION = "dashboard.read";

/**
 * Foydalanuvchida shu ruxsat bormi.
 *
 * ROL BO'YICHA TEKSHIRUV YO'Q va bo'lmaydi (ADR 0009): rollar ish
 * paytida yaratiladi va ularning nomi kodga ma'lum emas. Avval bu yerda
 * `ADMIN_ROLES.includes(role)` turardi — har yangi rol o'sha ro'yxatga
 * qo'shishni talab qilardi, va unutilgan joy jimgina teshik bo'lardi.
 *
 * Superadmin har doim o'tadi: uning huquqi ruxsatlar jadvaliga bog'liq
 * emas, aks holda yangi ruxsat qo'shilganda tizim egasi o'z panelining
 * bir qismidan chiqib qolardi.
 *
 * MUHIM: bu faqat INTERFEYS tekshiruvi. Haqiqiy cheklov backendda, har
 * bir endpointda (`@RequirePermission`) — brauzerdagi tekshiruvni
 * istalgan odam DevTools bilan chetlab o'tadi.
 */
export const hasPermission = (user: User | null | undefined, permission: string): boolean => {
  if (!user) return false;
  if (user.isSuperadmin) return true;
  return user.permissions.includes(permission);
};

/** Ro'yxatdagilardan BITTASI yetarli (OR). */
export const hasAnyPermission = (user: User | null | undefined, permissions: string[]): boolean =>
  permissions.some(permission => hasPermission(user, permission));

export const canAccessAdmin = (user: User | null | undefined): boolean =>
  hasPermission(user, ADMIN_ENTRY_PERMISSION);

/**
 * Yon menyu bandlarining ruxsatlari — sahifa ruxsatlaridan ALOHIDA.
 *
 * Menyu bandi va sahifa ikki xil savol. "Bu odam shikoyatlar
 * sahifasini ocha oladimi" — kirish huquqi, uni `reports.read`
 * hal qiladi. "Bu odam uni har kuni menyuda ko'rib tursinmi" — ish
 * o'rnining shakli, va uni menyu ruxsati hal qiladi.
 *
 * Menyu ruxsati HIMOYA EMAS: uni bermaslik sahifani yopmaydi, faqat
 * havolani yashiradi. Kirish har doim sahifaning o'z ruxsati bilan
 * tekshiriladi — bu yerda ham, backendda ham.
 */
export const SIDEBAR_PERMISSION = {
  DASHBOARD: "sidebar.dashboard",
  ANALYTICS: "sidebar.analytics",
  USERS: "sidebar.users",
  INVITATIONS: "sidebar.invitations",
  FINANCE: "sidebar.finance",
  LIVE: "sidebar.live",
  REPORTS: "sidebar.reports",
  REVIEWS: "sidebar.reviews",
  MESSAGES: "sidebar.messages",
  HOST_APPLICATIONS: "sidebar.host_applications",
  ROLES: "sidebar.roles",
  REFERENCE: "sidebar.reference",
  SETTINGS: "sidebar.settings",
  AUDIT: "sidebar.audit",
} as const;

/**
 * Panel bloklarining ruxsatlari.
 *
 * Har bir blok — o'z API si. Ruxsati yo'q blok uchun front so'rov ham
 * yubormaydi: bo'sh kartochka ko'rsatish "ma'lumot yuklanmadi" degan
 * xato bilan bir xil ko'rinardi.
 */
export const DASHBOARD_PERMISSION = {
  SUMMARY: "dashboard.summary.read",
  TIMESERIES: "dashboard.timeseries.read",
  FUNNEL: "dashboard.funnel.read",
  BREAKDOWN: "dashboard.breakdown.read",
  QUEUE: "dashboard.queue.read",
  TOP: "dashboard.top.read",
} as const;
